import {
  LuxButton,
  LuxCard,
  LuxTypography,
  useMediaQuery,
} from '@gemini/fe-ds-core';
import { ErrorMessage } from '@gemini/lux-ds-pms';
import { useOnlineBookingStore } from '@store/onlineBookingStore';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { conditionallyApplyUpperCase } from '@utils/functions';
import { useHistory } from 'react-router-dom';
import { ErrorPopupOverlay } from './ErrorManagementComponent.styles';
import { MobileBreakpoint } from '@utils/consts/breakpoints.consts';

interface ErrorManagementComponentProps {
  practiceInfoError?: AxiosError | null;
  formDataError?: AxiosError | null;
  configError?: AxiosError | null;
  scheduleConfigError?: AxiosError | null;
}

/**
 * Gestione centralizzata degli errori nel flusso di prenotazione online.
 */
const ErrorManagementComponent = ({
  practiceInfoError,
  formDataError,
}: ErrorManagementComponentProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const brandName = useOnlineBookingStore(state => state.brandName);
  const links = useOnlineBookingStore(state => state.links);
  const isMobile = useMediaQuery(`(max-width:${MobileBreakpoint}px)`);

  // If brandName exists, show a popup
  if (brandName) {
    return (
      <ErrorPopupOverlay>
        <LuxCard
          variant="default"
          headerComponent={
            <LuxTypography variant="heading3">
              {conditionallyApplyUpperCase(
                t('errors.generalErrorModalTitle'),
                brandName,
              )}
            </LuxTypography>
          }
          sx={{
            maxWidth: isMobile ? '100%' : '30rem',
            maxHeight: 'fit-content',
          }}
          sxContent={{ gap: '1rem' }}
        >
          <LuxTypography variant="textMdRegular">
            {t('errors.generalErrorModalContent')}
          </LuxTypography>
          <LuxButton
            variant="secondary"
            onClick={() =>
              links?.storeLocator
                ? (window.location.href = links?.storeLocator)
                : history.goBack()
            }
            sx={{ alignSelf: 'flex-end' }}
          >
            {conditionallyApplyUpperCase(
              t(
                `errors.${links?.storeLocator ? 'generalErrorModalBackToStoreCTA' : 'generalErrorModalBackCTA'}`,
              ),
              brandName,
            )}
          </LuxButton>
        </LuxCard>
      </ErrorPopupOverlay>
    );
  }

  // other cases -> old error management
  const is409 = practiceInfoError?.status === 409;

  if (is409) {
    return <ErrorMessage>{t('errors.error-page')}</ErrorMessage>;
  }

  const message =
    (practiceInfoError as any)?.message ??
    (formDataError as any)?.message ??
    null;

  return message ? <ErrorMessage>{message}</ErrorMessage> : null;
};

export default ErrorManagementComponent;
